import { GroupVarKey } from "./Generated/GroupVarKey.Data";
import { LeasePropKey } from "./Generated/LeasePropKey.Data";
import { LocationVarKey } from "./Generated/LocationVarKey.Data";
import { OrgVarKey } from "./Generated/OrgVarKey.Data";
import { TenantPropKey } from "./Generated/TenantPropKey.Data";
import { UnitPropKey } from "./Generated/UnitPropKey.Data";
import { UserPropKey } from "./Generated/UserPropKey.Data";
import { UserVarKey } from "./Generated/UserVarKey.Data";
import { VarKey } from "./Generated/VarKey.Data";
import { LimitToLocationType } from "./LocationVariables.Interface";

export enum VarType {
  Location = "Location",
  Unit = "Unit",
  User = "User",
  UserVar = "UserVar",
  Org = "Org",
  Group = "Group",
  Lease = "Lease",
  Tenant = "Tenant",
}
export type VarDefKeys = LocationVarKey | UserPropKey | UserVarKey | UnitPropKey | OrgVarKey | LeasePropKey | TenantPropKey | GroupVarKey;
export interface VarDefinition {
  type: VarType;
  key: VarDefKeys;
  varKey: VarKey;
  protected?: boolean;
  displayName: string;
  description: string;
  defaultValue: string;
  migrationKeys?: string[];
  limitTo?: LimitToLocationType;
}

export type VarDefinitionsType = {
  [K in VarKey]?: VarDefinition;
};
//This is a list of special keys that are not part of the VarDefinitionsType
export const SpecialVarKeys: VarKey[] = [VarKey.LocationFMSType];
